import { Toaster as Sonner } from "sonner";
import {
  CheckCircle2,
  XCircle,
  AlertTriangle,
  Info,
  Loader2,
} from "lucide-react";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  // Sempre usa tema light - não suportamos tema escuro no momento
  const theme = "light";
  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      closeButton
      icons={{
        success: <CheckCircle2 className="h-5 w-5" strokeWidth={2.25} />,
        error: <XCircle className="h-5 w-5" strokeWidth={2.25} />,
        warning: <AlertTriangle className="h-5 w-5" strokeWidth={2.25} />,
        info: <Info className="h-5 w-5" strokeWidth={2.25} />,
        loading: <Loader2 className="h-5 w-5 animate-spin" strokeWidth={2.25} />,
      }}
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:flex group-[.toaster]:items-center group-[.toaster]:gap-3 group-[.toaster]:w-full group-[.toaster]:rounded-xl group-[.toaster]:border group-[.toaster]:border-gray-200/60 group-[.toaster]:border-l-[6px] group-[.toaster]:bg-white/90 group-[.toaster]:backdrop-blur-md group-[.toaster]:p-4 group-[.toaster]:shadow-[0_12px_32px_rgba(15,23,42,0.12)] group-[.toaster]:transition-all group-[.toaster]:duration-300",
          icon: "group-[.toast]:flex group-[.toast]:items-center group-[.toast]:justify-center group-[.toast]:shrink-0 group-[.toast]:w-9 group-[.toast]:h-9 group-[.toast]:rounded-full group-[.toast]:m-0",
          content: "group-[.toast]:flex-1",
          title: "group-[.toast]:text-sm group-[.toast]:font-semibold group-[.toast]:text-gray-900",
          description: "group-[.toast]:text-sm group-[.toast]:text-gray-600",
          closeButton:
            "group-[.toast]:bg-white/80 group-[.toast]:text-gray-400 group-[.toast]:border-gray-200/70 hover:group-[.toast]:text-gray-700 hover:group-[.toast]:bg-white group-[.toast]:transition-colors",
          actionButton:
            "group-[.toast]:bg-linear-to-r group-[.toast]:from-blue-600 group-[.toast]:to-purple-600 group-[.toast]:text-white group-[.toast]:rounded-xl group-[.toast]:shadow-lg group-[.toast]:transform hover:group-[.toast]:-translate-y-0.5 group-[.toast]:transition-all group-[.toast]:duration-300",
          cancelButton:
            "group-[.toast]:bg-white/50 group-[.toast]:text-gray-800 group-[.toast]:border-2 group-[.toast]:border-gray-200/80 group-[.toast]:rounded-xl hover:group-[.toast]:bg-white/90 group-[.toast]:transition-all group-[.toast]:duration-300",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
